import React from 'react';
import { WebsiteDesignProps } from './types';
import { Hammer, Wrench, BrickWall, Lightbulb } from 'lucide-react';
import { Button } from "@/components/ui/button";

const IndustrialLoft: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "The Makers Loft";

    return (
        <div className="bg-[#2c2c2c] min-h-screen font-sans text-gray-200">
            {/* Brick Texture Header */}
            <div className="h-2 bg-orange-700/50" style={{backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 10px, rgba(0,0,0,0.1) 10px, rgba(0,0,0,0.1) 20px)'}}></div>

            <nav className="bg-[#1a1a1a] p-6 border-b border-gray-700 flex justify-between items-center sticky top-0 z-50 shadow-2xl">
                <div className="flex items-center gap-3">
                    <div className="bg-orange-600 p-2 rounded text-black font-bold border-2 border-black shadow-[2px_2px_0_gray]">
                        <Hammer size={24} />
                    </div>
                    <span className="text-2xl font-bold uppercase tracking-wider text-gray-100 shadow-black drop-shadow-md">{schoolName}</span>
                </div>
                <div className="hidden md:flex gap-8 font-bold text-gray-400 uppercase text-xs tracking-widest">
                     <a href="#" className="hover:text-orange-500 transition-colors">Workshop</a>
                     <a href="#" className="hover:text-orange-500 transition-colors">Projects</a>
                     <a href="#" className="hover:text-orange-500 transition-colors">Team</a>
                </div>
                <Button className="bg-orange-600 hover:bg-orange-700 text-black font-bold uppercase tracking-widest border border-black">
                    Start Building
                </Button>
            </nav>

            <main className="container mx-auto px-8 py-20">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
                    <div>
                         <h1 className="text-5xl md:text-7xl font-bold uppercase mb-8 leading-none tracking-tight text-white">
                             Built <br/> <span className="text-transparent bg-clip-text bg-[url('https://www.transparenttextures.com/patterns/dark-matter.png')] bg-orange-600">To Last.</span>
                         </h1>
                         <p className="text-xl text-gray-400 mb-10 font-light border-l-4 border-orange-600 pl-6">
                             Education stripped back to the raw essentials. Hands-on, practical, and resilient.
                         </p>
                         
                         <div className="bg-[#1f1f1f] p-8 border border-gray-700 shadow-xl relative mt-12">
                             <div className="absolute -top-3 -left-3 w-6 h-6 bg-gray-400 rounded-full border-4 border-[#1f1f1f]"></div>
                             <div className="absolute -top-3 -right-3 w-6 h-6 bg-gray-400 rounded-full border-4 border-[#1f1f1f]"></div>
                             <div className="absolute -bottom-3 -left-3 w-6 h-6 bg-gray-400 rounded-full border-4 border-[#1f1f1f]"></div>
                             <div className="absolute -bottom-3 -right-3 w-6 h-6 bg-gray-400 rounded-full border-4 border-[#1f1f1f]"></div>
                             
                             <h3 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
                                 <Lightbulb className="text-yellow-500" /> Innovation Hub
                             </h3>
                             <p className="text-gray-400 text-sm leading-relaxed">
                                 Our campus is converted from a 1920s textile factory, providing massive open spaces for collaboration, robotics, and creative arts.
                             </p>
                         </div>
                    </div>

                    <div className="relative group">
                         <div className="border-8 border-gray-800 shadow-2xl overflow-hidden">
                             <img src="https://images.unsplash.com/photo-1581093450065-236b513d26bc?q=80&w=2070&auto=format&fit=crop" className="w-full grayscale hover:grayscale-0 transition-all duration-700" alt="Industrial" />
                         </div>
                         <div className="absolute -bottom-6 -right-6 bg-orange-600 text-black font-bold p-6 text-center shadow-lg border-2 border-black">
                             <div className="text-3xl">100%</div>
                             <div className="text-xs uppercase">Employment</div>
                         </div>
                    </div>
                </div>

                <div className="mt-24 border-t border-gray-700 pt-12 flex justify-between text-gray-500 font-mono text-sm">
                    <div className="flex items-center gap-2"><BrickWall size={16} /> EST. 2015</div>
                    <div className="flex items-center gap-2"><Wrench size={16} /> PRACTICAL SKILLS</div>
                    <div className="flex items-center gap-2"><Hammer size={16} /> REAL TOOLS</div>
                </div>
            </main>
        </div>
    );
};

export default IndustrialLoft;
